import type { ReactNode } from 'react';
import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const {
  learnMoreText
} = translate({
  "learnMoreText": "Find out more"
});
export const refundText = translateFormatter<{
  amount: ReactNode;
}>("Up to {amount} cashback", undefined, undefined, "en");